import { render, staticRenderFns } from "./CotPropostaAccessoSchedeValutazioneComponent.vue?vue&type=template&id=7e47a18f"
import script from "./CotPropostaAccessoSchedeValutazioneComponent.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoSchedeValutazioneComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports